import {selector} from './selector';
import * as events from "./events";

const PageCustomerProfileBills = (function ($) {

    function initEvents() {
        $(document).on('click', selector.invoicePreview, events.invoicePreviewModal);
        $(document).on('click', selector.btnAddCredit, events.addCreditAmount); 
        $(document).on('click',selector.btnPayBill, events.payBill)
    }

    function initialize() {
        initEvents();
    }

    return {
        init: initialize
    }
})(jQuery);

export {PageCustomerProfileBills};